$(document).ready(function () {
    const hasSubscribed = localStorage.getItem('userSubscribed') === 'true';
    const popupShown = sessionStorage.getItem('popupShown') === 'true';

    if (hasSubscribed) return;

    if (!popupShown) {
        setTimeout(function () {
            $('section.clNewsletter-popup').addClass('active');
            sessionStorage.setItem('popupShown', 'true');
        }, 6000);
    }
});
// Close popup handler
$(document).on('click', 'section.clNewsletter-popup .poup_header button.closePopup', function () {
    $('section.clNewsletter-popup').removeClass('active');
});
// Email input and UI interactions
$(document).ready(function () {
    var $emailInput = $('section.clNewsletter-popup #email');
    var $emailWrapper = $emailInput.closest('section.clNewsletter-popup .email');
    var $newsletterContent = $('section.clNewsletter-popup .newsletterContent');

    $emailInput.on('focus', function () {
        $emailWrapper.addClass('active');
        $newsletterContent.stop(true, true).slideDown();
    });

    $emailInput.on('blur', function () {
        if ($emailInput.val().trim() === '') {
            $emailWrapper.removeClass('active');
        }
    });

    $('section.clNewsletter-popup .newsletterContent .gender label input[type="checkbox"]').change(function () {
        var $inputBox = $(this).closest('.inputBox');

        if ($(this).is(':checked')) {
            $inputBox.addClass('active');
        } else {
            $inputBox.removeClass('active');
        }
    });
});
// Form validation and submission
$(document).ready(function () {
    var $form = $('.clNewsletter-popup form[action*="/contact"]');
    var $email = $form.find('section.clNewsletter-popup #email');
    var $errorEmail = $form.find('section.clNewsletter-popup .errorEmail');
    var $checkboxes = $form.find('section.clNewsletter-popup input[type="checkbox"]');
    var $errorCheckbox = $form.find('section.clNewsletter-popup .errorCheckbox');
    $errorEmail.hide();
    $errorCheckbox.hide();
    $form.on('submit', function (e) {
        var isValid = true;

        // Email validation
        var emailVal = $email.val().trim();
        if (emailVal === '') {
            $errorEmail.show();
            $email.focus();
            isValid = false;
        } else {
            $errorEmail.hide();
        }

        // Checkbox validation
        var isAnyChecked = $checkboxes.is(':checked');
        if (!isAnyChecked) {
            $errorCheckbox.show();
            if (isValid) $checkboxes.first().focus();
            isValid = false;
        } else {
            $errorCheckbox.hide();
        }

        if (!isValid) {
            e.preventDefault();
            e.stopImmediatePropagation();
        } else {
            // Mark user as subscribed when form is successfully submitted
            localStorage.setItem('userSubscribed', 'true');
            localStorage.setItem('subscribedEmail', emailVal);
            localStorage.setItem('subscriptionDate', new Date().toISOString());

            // Delay to let the form submit, then clear email
            setTimeout(function () {
                $email.val('');
            }, 100);
        }
    });
});
// Submit button state management
$(document).ready(function () {
    var $form = $('.clNewsletter-popup form[action*="/contact"]');
    var $email = $form.find('#email');
    var $checkboxes = $form.find('input[type="checkbox"]');
    var $submitBtn = $form.find('input[type="submit"]');
    function toggleSubmitActive() {
        var emailFilled = $email.val().trim() !== '';
        var checkboxChecked = $checkboxes.is(':checked');
        if (emailFilled && checkboxChecked) {
            $submitBtn.addClass('active');
        } else {
            $submitBtn.removeClass('active');
        }
    }
    $email.on('input', toggleSubmitActive);
    $checkboxes.on('change', toggleSubmitActive);
});
// Handle successful subscription and thank you display
$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const isFormPosted = urlParams.get('customer_posted') === 'true';
    const isContactForm = window.location.hash === '#contact_form';

    if (isFormPosted && isContactForm) {
        // Mark user as subscribed
        localStorage.setItem('userSubscribed', 'true');

        $('section.clNewsletter .newsletterContent').show();
        $('section.clNewsletter .thankYouContent').show();
        sessionStorage.removeItem('popupShown');
    }
    // Close popup and clean URL
    $(document).on('click', 'section.clNewsletter-popup .poup_header button.closePopup', function () {
        $('section.clNewsletter-popup').removeClass('active thank-you');

        // Clean URL: remove customer_posted and hash
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState({}, document.title, url.toString());
    });
});
// Optional: Function to reset subscription status (for testing or admin purposes)
function resetSubscriptionStatus() {
    localStorage.removeItem('userSubscribed');
    localStorage.removeItem('subscribedEmail');
    localStorage.removeItem('subscriptionDate');
    sessionStorage.removeItem('popupShown');
    console.log('Subscription status reset');
}
// Optional: Function to check subscription status
function getSubscriptionStatus() {
    return {
        isSubscribed: localStorage.getItem('userSubscribed') === 'true',
        email: localStorage.getItem('subscribedEmail'),
        subscriptionDate: localStorage.getItem('subscriptionDate')
    };
}